<style>
	.edi-detail-bill{
		position: relative;
		width: 100%;
		height: 100%;
		overflow:hidden;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-input{
		border:solid 1px #eee;
		display: inline-block;
		width: 80px;
		margin: 0;
		padding: .5em;
		outline: none;
		font-size: 1em;
		background: none;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-span{
		box-sizing: border-box;
		border:solid 1px #eee;
		display: inline-block;
		width: 80px;
		padding: .5em;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-taxinput{
		border:solid 1px #eee;
		width: 60px;
		background-color: #f1f1f1;
		/*text-align: center;*/
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-percent{
		position: relative;
	}
	.edi-detail-bill .detail-bill-sonlist li .detail-bill-edit-percent:after{
		content: '%';
		position: absolute;
		top:0;
		left: -22px
	}
	.edi-detail-bill .detail-bill-sonlist li .tax-operate{

		position: relative;
		padding: 5px 12px;
		/*top: 11px;*/
		margin:0px 5px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: 80%;
	}
	 .edi-detail-bill .detail-bill-sonlist li .tax-operate-reduce{
		background-image: url('../assets/allorderbill/reduce.png');
	}
	.edi-detail-bill .detail-bill-sonlist li .tax-operate-plus{
		background-image: url('../assets/allorderbill/plus.png');
	}

</style>
<template>
	<div class="edi-detail-bill">
		<!-- <div class="filter">
			<input type="text" placeholder="" class="ui-search-input"/>
		</div> -->
		<navbar title="餐企询价单-明细编辑"></navbar>
		<div class="common-scroll detail-scroll">
			<p class="detail-bill-status">
				{{detailData.trans_bill_no}}
				<span class="nav-btn" @click="openBillInfo()">
					<img src="../assets/nav-btn.png" alt="">
				</span>
				<span class="state-aqua-font">已同意</span>
			</p>
			<div class="bill-all-info" v-show="billInfoShow">
				<ul class="detail-bill-info-list">
					<li class="detail-bill-fulllist">询价企业：{{detailData.restaurant_name}}</li>
					<li class="detail-bill-fulllist detail-bill-remark">整单备注：{{detailData.remark}}</li>
				</ul>
			</div>
			<div class="detail-bill-search-wrapper">
				<input class="detail-search-input" placeholder="请输入要搜索的品项名称" v-model="searchWord">
			</div>
			<div class="detail-bill-wrapper">
				<h4 class="detail-bill-address aqua-font">
					<span class="list-btn fl">
						<img src="../assets/list_open.png" alt="">
					</span>
					明细条目({{detailsFilter.length}})
					<a class="detail-bill-edit state-aqua-font" @click="cancel">取消</a>
				</h4>
				<ul class="detail-bill-list">
					<li v-for="detail in detailsFilter" :key="detail.goods_id">
						<ul class="detail-bill-sonlist">
							<li class="detail-bill-fulllist detail-bill-list-title">
								{{detail.goods_name}}({{detail.goods_unit}})
							</li>
							<li v-if="isPesc">规格：{{detail.goods_spec}}</li>
							<li>税率
								<span style="position: relative" v-if="detailData.can_change_price">
									<span class="tax-operate tax-operate-reduce" @click="reduce(detail)"></span>
									<input type="text" class="detail-bill-edit-taxinput" v-model="detail.goods_cess || 0" readonly />
									<span class="detail-bill-edit-percent"></span>
									<span class="tax-operate tax-operate-plus" @click="plus(detail)"></span>
								</span>
								<span style="position: relative; left: -10px" v-else>
									<input type="text" class="detail-bill-edit-taxinput" v-model="detail.goods_cess || 0" readonly />
								</span>
							</li>
							<li>含税单价：
								<input type="text" class="detail-bill-edit-input" v-model="detail.goods_price_send" v-if="detailData.can_change_price" @blur="sendPriceCountFixed(detail)"/>
								<input type="text" class="detail-bill-edit-input" v-model="detail.goods_price_send" readonly onfocus="this.blur()" v-else/>
							</li>
              <li v-show="isZ5 && inquiryAmountFlag">询价数量：{{detail.goods_num_sended | numFixed(4)}}</li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="detail-bill-search-empty" v-if="!detailsFilter.length">
				<div class="middle-empty"></div>
				<p>未找到相关品项</p>
			</div>
		</div>
		<div class="detail-bill-footer">
			<div class="detail-bill-return f-right">
				<a @click="save">保存</a>
			</div>
			<div class="detail-bill-agreen f-right">
				<a @click="billConfirm">确认</a>
			</div>
		</div>
		<div class="tips-mask-t" v-show="tipsTwoShow" @click.stop="hideRuturnConfirm">
			<div class="tips-wrapper" :class="{'tips-start':tipsTwoShow,'tips-end':!tipsTwoShow}">
				<div class="tips-font">
					<p>{{elseTipsFont}}</p>
				</div>
				<div class="tips-btns">
					<a class="tips-two-btn tips-marbot red-font" @click.stop="saveReturn">{{elseBtnFont[0]}}</a>
					<a class="tips-two-btn tips-marbot" @click.stop="quitRuturn">{{elseBtnFont[1]}}</a>
					<a class="tips-two-btn" @click.stop="hideRuturnConfirm">{{elseBtnFont[2]}}</a>
				</div>
			</div>
		</div>
		<loading v-show="loading"></loading>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFontWaring="tipsWaring" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>
<script>
import Loading from '../components/loading'
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
import NavBar from '../components/NavBar'
import { GlobalStore } from '../store/globalStore'
export default {
	data () {
		return {
			skipRoute: false,
			show: false,
			tips: false,
			tipsWaring: false,
			tipsauto: false,
			sec: 1500,
			msg: [],
			btnNum: 2,
			tipsFont: '',
			loading: true,
			details: [],
			detailData: {},
			index: 0,
			cess_data: [0, 3, 6, 8, 13, 17],
			unitPrice: [],
			queryData: this.$route.query,
			nanArr: [],
			allInfo: '',
			numScale: 2,
			// numPatrn: /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/,
			numPatrn: /^(([0-9]+[\.]?[0-9]+)|[1-9])$/,
			deviceHeight: this.$root.deviceHeight,
			elseTipsFont: '当前单据明细尚未保存',
			elseBtnFont: ['保存并返回', '放弃并返回', '取消'],
			tipsTwoShow: false,
			editStatus: true,
			store: GlobalStore,
			goodsTotalInfo: {},
			billInfoShow: false,
			searchWord: '',
			isPesc: false,
			isZ5: false,
			inquiryAmountFlag: false
		}
	},
	components: {
		'loading': Loading,
		'tips': Tips,
		'tips-auto': TipsAuto,
		'navbar': NavBar
	},
	beforeRouteLeave (to, from, next) {
		if (this.skipRoute) {
			next()
			return
		}
		if (this.editStatus) {
			next(false)
			this.tipsTwoShow = true
		} else {
			next()
		}
	},
	created () {
		this.goodsTotalInfo = this.store.goodsTotalInfo
		window.console.log(this.goodsTotalInfo)
		this.loading = true
		this.searchWord = this.queryData.searchWord
		var filterData = {
			bill_id: this.queryData.bill_id
		}
		this.$http.post('/cldEdi/business/billWithDetail', filterData).then(response => {
			const forceUploadPermitFlag = (!response.body.otherdata || response.body.otherdata.forceUploadPermitFlag === null) ? false : response.body.otherdata.forceUploadPermitFlag
			this.isZ5 = response.body.otherdata == null ? false : response.body.otherdata.isZ5
			this.inquiryAmountFlag = response.body.otherdata == null ? false : response.body.otherdata.inquiryAmountFlag

			if (!this.isZ5 && forceUploadPermitFlag === true) {
				this.$fxToast.warning('请上传供货商证照信息！')
				this.$router.replace({path: '/main/my'})
			}
			this.loading = false
			this.detailData = response.body.data
			this.numScale = this.detailData.number_scale || 2
			this.details = response.body.data.details
			this.isPesc = this.detailData.isPesc // 是否显示规格的系统参数
			this.dataHandle()
		})
	},
	methods: {
		toFixed (value) {
			return parseFloat(value.toFixed(this.numScale))
		},
		saveReturn () {
			this.tipsTwoShow = false
			this.loading = true
			var details = this.detailData.details
			for (var i = 0; i < details.length; i++) {
				if (isNaN(details[i].sub_total_send) || isNaN(details[i].goods_num_send) || isNaN(details[i].goods_price_send)) {
					this.nanArr.push(details[i].sub_total_send) || this.nanArr.push(details[i].goods_num_send) || this.nanArr.push(details[i].goods_price_send)
				}
			}
			// window.console.log(this.nanArr)
			if (this.nanArr.length !== 0) {
				this.loading = false
				this.autoTips('所填项必须为数字')
				return false
			}
			this.editStatus = false
			this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.loading = false
				var data = response.body
				if (data.result) {
					this.$router.replace({path: '/all-order-bill', query: this.goodsTotalInfo.queryData})
				} else {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		quitRuturn () {
			this.editStatus = false
			this.tipsTwoShow = false
			this.$router.replace({path: '/all-order-bill', query: this.goodsTotalInfo.queryData})
		},
		hideRuturnConfirm () {
			this.editStatus = true
			var route = this.$route
			var path = route.path
			var query = route.query
			this.tipsTwoShow = false
			this.skipRoute = true
			this.$router.replace('/all-order-bill')
			this.$router.push({
				path: path,
				query: query
			})
			this.skipRoute = false
		},
		dataHandle () {
			var data = this.details
			var arr = this.detailData.goods_cess_array.split(',')
			for (var i = 0; i < data.length; i++) {
				data[i].goods_cess_array = arr
				data[i].goods_price_send_notax = data[i].goods_price_send / (1 + data[i].goods_cess / 100)
				var index = data[i].goods_cess_array.indexOf(data[i].goods_cess + '')
				data[i].goods_cess_index = index
			}
			// window.console.log(data)
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		tipStatus (msg) {
			this.tips = false
			this.msg = msg
			if (this.tipsWaring) {
				this.tipsWaring = false
				this.btnNum = 2
				return false
			}
			if (this.msg[1]) {
				this.confirmPost()
				return false
			}
		},
		sendPriceCountFixed (detailData) {
			// detailData.goods_price_send = parseFloat(this.detailData.goods_price_send)
			// detailData.goods_price_send = detailData.goods_price_send.toFixed(2)
			if (!(this.numPatrn.test(detailData.goods_price_send))) {
				this.autoTips('含税单价只能是正数')
				detailData.goods_price_send = 0.00
				detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				return false
			}
			if (this.detailData.goods_price_send > 100000) {
				this.autoTips('含税单价有效值范围：0~99999')
				detailData.goods_price_send = 0.00
				detailData.sub_total_send = detailData.goods_num_send * detailData.goods_price_send
				detailData.sub_total_send = this.toFixed(detailData.sub_total_send)
				return false
			}
		},
		plus (detailData) {
			var noTaxPrice = detailData.goods_price_send / (1 + detailData.goods_cess / 100)
			var goodsCessArray = detailData.goods_cess_array
			if (detailData.goods_cess_index < goodsCessArray.length - 1) {
				detailData.goods_cess_index++
			} else {
				detailData.goods_cess_index = goodsCessArray.length - 1
			}
			detailData.goods_cess = detailData.goods_cess_array[detailData.goods_cess_index]
			detailData.goods_price_send = noTaxPrice * (1 + detailData.goods_cess / 100)
			detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
		},
		reduce (detailData) {
			var noTaxPrice = detailData.goods_price_send / (1 + detailData.goods_cess / 100)
			if (detailData.goods_cess_index > 0) {
				detailData.goods_cess_index --
			} else {
				detailData.goods_cess_index = 0
			}
			detailData.goods_cess = detailData.goods_cess_array[detailData.goods_cess_index]
			detailData.goods_price_send = noTaxPrice * (1 + detailData.goods_cess / 100)
			detailData.goods_price_send = this.toFixed(detailData.goods_price_send)
		},
		billConfirm () {
			this.tips = true
			this.tipsFont = '是否保存并确认？'
		},
		save () {
			this.loading = true
			var details = this.detailData.details
			for (var i = 0; i < details.length; i++) {
				if (isNaN(details[i].sub_total_send) || isNaN(details[i].goods_num_send) || isNaN(details[i].goods_price_send)) {
					this.nanArr.push(details[i].sub_total_send) || this.nanArr.push(details[i].goods_num_send) || this.nanArr.push(details[i].goods_price_send)
				}
			}
			if (this.nanArr.length !== 0) {
				this.loading = false
				this.autoTips('所填项必须为数字')
				return false
			}
			this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.editStatus = false
				this.loading = false
				var data = response.body
				if (data.result) {
					this.$router.replace({path: '/detail-inquiry-price-bill', query: { bill_id: this.queryData.bill_id }})
				} else {
					this.autoTips(data.message)
					return
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		confirmPost () {
			this.loading = true
			var details = this.detailData.details
			for (var i = 0; i < details.length; i++) {
				if (isNaN(details[i].goods_price_send)) {
					this.nanArr.push(details[i].goods_price_send)
				}
			}
			// window.console.log(this.nanArr)
			if (this.nanArr.length !== 0) {
				this.loading = false
				this.autoTips('请输入数字')
				return false
			}
			this.detailData.bill_state = 42
			// window.console.log(this.detailData)
			this.$http.post('/cldEdi/business/bill/updateWithDetail', this.detailData).then((response) => {
				this.loading = false
				this.editStatus = false
				var data = response.body
				if (data.result) {
					// 需求:明细编辑页面点击发货成功后 跳转明细页面 2017/6/30 shang
					this.$router.push({path: '/detail-inquiry-price-bill', query: { bill_id: this.queryData.bill_id }})
				} else {
					this.autoTips('失败')
					this.editStatus = true
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		cancel () {
			this.editStatus = false
			this.$router.replace({path: '/detail-inquiry-price-bill', query: { bill_id: this.queryData.bill_id }})
		},
		readonlyIOS () {
			this.$el.blur()
		},
		openBillInfo () {
			this.billInfoShow = !this.billInfoShow
		}
	},
	filters: {
		// edi小数位数处理
		numFixed (val, scale) {
			// if ((typeof val === 'string' && val !== '') || typeof val === 'number') {
			// 	if (scale) {
			// 		return parseFloat(val).toFixed(scale)
			// 	} else {
			// 		return val
			// 	}
			// } else {
			return val
			// }
		}
	},
	computed: {
		detailsFilter () {
			if (this.searchWord.trim()) {
				return this.details.filter(detail => detail.goods_name.indexOf(this.searchWord.trim()) >= 0)
			} else {
				return this.details
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// InquiryPriceDetailEdit.vue?3d313357